import { Navigate, useLocation } from 'react-router-dom';

/**
 * Keeps a single URL shape: no trailing slash (except homepage).
 * Server 301s handle SEO status codes; this covers SPA / local navigation.
 */
function TrailingSlashRedirect() {
  const { pathname, search, hash } = useLocation();

  if (pathname !== '/' && pathname.endsWith('/')) {
    return <Navigate to={`${pathname.replace(/\/+$/, '')}${search}${hash}`} replace />;
  }

  return null;
}

export default TrailingSlashRedirect;
